import request from '@/utils/request'

const tradeProjectCostAttachmentApi = {
  trade_project_cost_attachment_list: '/trade/project_cost_attachment/',
  trade_project_cost_attachment_create: '/trade/project_cost_attachment/',
  trade_project_cost_attachment_update: '/trade/project_cost_attachment/',
  trade_project_cost_attachment_delete: '/trade/project_cost_attachment/'
}

/**
 * 列表
 */
export function project_cost_attachment_list (parameter) {
  return request({
    url: tradeProjectCostAttachmentApi.trade_project_cost_attachment_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function project_cost_attachment_create (parameter) {
  return request({
    url: tradeProjectCostAttachmentApi.trade_project_cost_attachment_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function project_cost_attachment_update (parameter, project_cost_attachment_id) {
  return request({
    url: tradeProjectCostAttachmentApi.trade_project_cost_attachment_update + project_cost_attachment_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function project_cost_attachment_delete (project_cost_attachment_id) {
  return request({
    url: tradeProjectCostAttachmentApi.trade_project_cost_attachment_delete + project_cost_attachment_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
